/*
 * Copyright (c) 2022-2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React, {Component} from 'react';
import GlobalPortal from "./GlobalPortal.jsx";
import PropTypes from "prop-types";
import {UI} from "../UIGenerator.jsx";

class SystemCursor extends Component {

    constructor() {
        super();

        this.cursorDiv = React.createRef()
    }


    componentDidMount() {
        let {iconName, color = "black", size = "1.9em", querySelector, uiId} = this.props


        let targetElement = document.querySelector(querySelector)

        let targetRec = targetElement.getBoundingClientRect()

        if (this.cursorDiv.current !== undefined) {
            let style = getComputedStyle(targetElement)

            this.cursorDiv.current.style.borderRadius = style.getPropertyValue("border-top-left-radius")
            this.cursorDiv.current.style.width = targetRec.width + "px"
            this.cursorDiv.current.style.height = targetRec.height + "px"
            this.cursorDiv.current.style.transform = `translate3d(${targetRec.left}px, ${targetRec.top}px, 0)`;

        }

        setTimeout(() => {

            UI.page().close(uiId)

        }, 1000)

    }

    componentWillUnmount() {


    }

    render() {
        let {iconName, color = "black", size = "1.9em", querySelector} = this.props

        return (
            <GlobalPortal>
                <div
                    className={`top-0 left-0 fixed w-screen h-screen  z-50 pointer-events-none`}>

                    {/*The fake courser */}
                    <div ref={this.cursorDiv}
                         className={"fixed transform will-change-transform border border-blue-600 bg-blue-100/10"}>
                        {/*<DisplayIcon iconName={iconName} size={size} color={color}/>*/}

                        {/*Test*/}


                    </div>
                </div>
            </GlobalPortal>
        );
    }
}

SystemCursor.propTypes = {
    querySelector: PropTypes.any
};

SystemCursor.defaultProps = {}
export default SystemCursor;